import { styled, SxProps } from "@mui/material";
import React from "react";
import CustomColor from "../../../utils/overrides/color";

interface ILoadingProps {
  width?: number;
  height?: number;
  sx?: SxProps;
}
export default function LoadingBox(props: ILoadingProps) {
  const Box = styled("div")({
    width: props.width ? `${props.width}px` : "88px",
    height: props.height ? `${props.height}px` : "88px",
    backgroundColor: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "12px",
    "& .bt-spinner": {
      width: props.width ? `${props.width}px` : "48px",
      height: props.height ? `${props.height}px` : "48px",
      borderRadius: "50%",
      backgroundColor: "transparent",
      border: "3px solid #E5E7E9",
      borderTop: `3px solid ${CustomColor["primary-500"]}`,
      WebkitAnimation: "1s spin linear infinite",
      animation: "1s spin linear infinite",
    },
  });
  return (
    <Box sx={props.sx}>
      <div className="bt-spinner"></div>
    </Box>
  );
}
